import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  private http = inject(HttpService);

  public create = async (body: any) => await this.http.post(`/v1/provider`, body, false).then((response: any) => response.data);

  public list = async () => await this.http.get(`/v1/provider`, false).then((response: any) => response.data.content.sort());

  public module = async (module: string) => await this.http.get(`/v1/provider/${module}`, false).then((response: any) => response.data.content.sort());

  public update = async (id: number, body: any) => await this.http.put(`/v1/provider/${id}`, body, false).then((response: any) => response.data);
}
